import { FC } from 'react'
import { Code } from 'lucide-react'

interface Props {
  isJsonView: boolean
  onToggle: (isJson: boolean) => void
}

const ViewToggle: FC<Props> = ({ isJsonView, onToggle }) => {
  return (
    <button
      onClick={() => onToggle(!isJsonView)}
      className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full p-0.5 transition-colors duration-200 ease-in-out focus:outline-none ${
        isJsonView ? 'bg-blue-600' : 'bg-gray-200'
      }`}
      role='switch'
      aria-checked={isJsonView}
      aria-label='Toggle JSON view'
    >
      <span
        className={`relative inline-block h-5 w-5 transform rounded-full bg-white shadow-sm transition-transform duration-200 ease-in-out ${
          isJsonView ? 'translate-x-5' : 'translate-x-0'
        }`}
      >
        {/* Code icon - always shown, color changes based on state */}
        <span
          aria-hidden='true'
          className='absolute inset-0 flex h-full w-full items-center justify-center'
        >
          <Code size={10} className={isJsonView ? 'text-blue-600' : 'text-gray-400'} />
        </span>
      </span>
    </button>
  )
}

export default ViewToggle
